import React from 'react';

import { IWidgetCardsListProps } from '@entities/widget-card/model/types';
import { UiText } from '@shared/ui';

import cls from './WidgetCardsList.module.css';

export const WidgetCardsList = ({ title, children }: IWidgetCardsListProps) => (
    <section className={cls.listWrapper}>
        <UiText tag="h2" className={cls.title} variant="boldPlain" weight="medium">
            {title}
        </UiText>
        <ul className={cls.listContainer}>{children}</ul>
    </section>
);
